import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  userForgotPassword,
  resetStatus,
} from "features/common/auth/authSlice";
import Spinner from "react-bootstrap/Spinner";
import Modal from "react-bootstrap/Modal";
import { notifyWarning, notifySuccess, notifyError } from "components/ToastMessage";

const ModalForgotPassword = (props) => {
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  
  // States
  const [email, setEmail] = useState("");
  const [submitDisable, setSubmitDisable] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const handlerForgot = (e) => {
    e.preventDefault();
    
    if (!email) {
      notifyWarning("Email Anda kosong!");
      return;
    }
    
    // Validate email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      notifyWarning("Format email tidak valid!");
      return;
    }
    
    setSubmitDisable(true);
    dispatch(userForgotPassword(email));
  };

  const handleCloseModal = () => {
    // Reset all states
    setEmail("");
    setSubmitDisable(false);
    setIsSuccess(false);
    props.onHide();
  };

  useEffect(() => {
    if (auth.status === "fulfilled") {
      setSubmitDisable(false);
      setIsSuccess(true);
      // Notifikasi success akan ditampilkan di UI modal, tidak perlu notifySuccess di sini
      dispatch(resetStatus("idle"));
    } else if (auth.status === "error" && props.show) {
      setSubmitDisable(false);
      // Handle new API response structure more robustly
      let errorMessage = "Terjadi kesalahan saat mengirim link reset password";
      
      if (auth.error) {
        // Handle direct API response structure: {success: false, error: "message"}
        if (typeof auth.error === 'string') {
          errorMessage = auth.error;
        } 
        // Handle nested error in response payload
        else if (auth.error.error && typeof auth.error.error === 'string') {
          errorMessage = auth.error.error;
        }
        // Handle message in error object
        else if (auth.error.message && typeof auth.error.message === 'string') {
          errorMessage = auth.error.message;
        }
        // Handle nested error with message
        else if (auth.error.error && auth.error.error.message) {
          errorMessage = auth.error.error.message;
        }
      }
      
      notifyError(errorMessage);
      dispatch(resetStatus("idle"));
    } else if (auth.status === "idle") {
      setSubmitDisable(false);
    }
  }, [dispatch, auth.status, auth.error, props.show]);

  return (
    <>
      {/* modal for forgot password */}
      <Modal
        show={props.show}
        onHide={handleCloseModal}
        backdrop="static"
        keyboard={false}
        size="sm"
        aria-labelledby="example-custom-modal-styling-title"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-custom-modal-styling-title">
            Reset Password
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {!isSuccess ? (
            // Step 1: Request Reset Password
            <div>
              <p>
                Lupa Password akun anda? Masukan alamat email dibawah ini untuk
                mendapatkan link reset password.
              </p>
              <div className="mb-3">
                <label htmlFor="email" className="form-label label-qwords">
                  Masukkan Email
                </label>
                <input
                  type="email"
                  className="form-control input-modal"
                  id="email"
                  aria-describedby="emailHelp"
                  placeholder="email@qwords.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
            </div>
          ) : (
            // Success Message
            <div className="text-center">
              <div className="mb-3">
                <i className="fas fa-check-circle text-success" style={{ fontSize: '3rem' }}></i>
              </div>
              <h5 className="text-success mb-3">Link Reset Password Terkirim!</h5>
              <p>
                Kami telah mengirim link reset password ke email <strong>{email}</strong>. 
                Silakan cek email Anda dan ikuti instruksi untuk reset password.
              </p>
              <div className="alert alert-info">
                <small>
                  <i className="fas fa-info-circle me-1"></i>
                  Jika tidak menemukan email, cek folder spam atau junk mail.
                </small>
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <div className="row col-12">
            {!isSuccess ? (
              <button
                className="btn btn-modal-login"
                onClick={handlerForgot}
                disabled={submitDisable}
              >
                {auth.status === "loading" ? (
                  <Spinner animation="border" size="sm" />
                ) : (
                  "Kirim Link Reset Password"
                )}
              </button>
            ) : (
              <button
                className="btn btn-modal-login"
                onClick={handleCloseModal}
              >
                Tutup
              </button>
            )}
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ModalForgotPassword;
